//流动线材质
export default `
uniform vec4 color;
uniform float repeat;
uniform float offset;
uniform float thickness;
czm_material czm_getMaterial(czm_materialInput materialInput)
{
  czm_material material = czm_getDefaultMaterial(materialInput);
  float sp = 1.0/repeat;
  vec2 st = materialInput.st;
  float dis = distance(st, vec2(0.5));
  float m = mod(dis + (offset)*st.t-time, sp);
  float a = step(sp*(1.0-thickness), m);
  material.diffuse = color.rgb;
  material.alpha = a * color.a * dis * 1.2;
  return material;
}                                 
 `